import { userPermissionApis } from "../Data/axios";

let cachedPermissions = null;

export async function loadTicketPermissions() {
  if (Array.isArray(cachedPermissions)) {
    return cachedPermissions;
  }

  try {
    const result = await userPermissionApis.getOtherPermissions();
    cachedPermissions = Array.isArray(result?.permissions) ? result.permissions : [];
  } catch (error) {
    console.error("Error loading user permissions:", error);
    cachedPermissions = [];
  }

  return cachedPermissions;
}

export function hasTicketPermission(permissions, key) {
  if (!Array.isArray(permissions)) return false;
  return permissions
    .map((item) => String(item).trim().toLowerCase())
    .includes(String(key).trim().toLowerCase());
}
